import { type DateLike, type JalaliStyle, formatJalali, toDate } from "../lib/jalali";
import { cx } from "../utils/cx";

export interface JalaliDateProps {
    value: DateLike;
    /** long: «12 مهر 1405» · short: «1405/07/12» · dayMonth · monthYear · weekday · datetime */
    format?: JalaliStyle;
    className?: string;
}

/** A Jalali date in a semantic <time> element; the full date and time sit in the title for hover. */
export const JalaliDate = ({ value, format = "long", className }: JalaliDateProps) => {
    const d = toDate(value);
    if (Number.isNaN(d.getTime())) return null;

    return (
        <time dateTime={d.toISOString()} title={formatJalali(d, "datetime")} className={cx("whitespace-nowrap", className)}>
            {formatJalali(d, format)}
        </time>
    );
};
